import React, { useState } from 'react'
import { Modal, Button, Table, FormControl } from 'react-bootstrap'
import RateConModal from './RateConModal'
import PodReceipts from './PodReceipts'
const JobsModal = ({ show, onHide, jobs }) => {
  // 🔹 Static jobs data

  const [showRateCon, setShowRateCon] = useState(false)
  const [currentRC, setCurrentRC] = useState(null)

  const [showPod, setShowPod] = useState(false)
  const [currentPod, setCurrentPod] = useState(null)

  const handleOpenRateCon = job => {
    setCurrentRC(job)
    setShowRateCon(true)
  }
  const handleOpenPod = job => {
    setCurrentPod(job)
    setShowPod(true)
  }

  return (
    <Modal show={show} onHide={onHide} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Jobs for Payday Statement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
          }}
        >
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Completed Date</th>
                <th>Assigned Date</th>
                <th>Pickup</th>
                <th>Drop-off Location</th>
                <th>Rate Con</th>
                <th>POD/Receipts</th>
                <th>Job Amount</th>
                <th>Broker Name</th>
                <th>RC Number</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map(job => (
                <tr key={job.id}>
                  <td>{job?.id}</td>
                  <td>{job?.job?.completed_date}</td>
                  <td>{job?.assignedDate}</td>
                  <td>{job?.job?.pickup_address}</td>
                  <td>{job?.job?.drop_address}</td>
                  <td>
                    {job?.job?.rate_confirmation_document ? (
                      <Button variant='link' size='sm' onClick={() => handleOpenRateCon(job)}>
                        View
                      </Button>
                    ) : (
                      <div className={'badge bg-danger'}>No Rate Doc</div>
                    )}
                  </td>
                  <td>
                    <td>
                      <Button
                        variant='link'
                        size='sm'
                        onClick={() => {
                          console.log('Clicked POD JOB:', job)
                          handleOpenPod(job)
                        }}
                      >
                        View
                      </Button>
                    </td>
                  </td>
                  <td>${job?.job?.job_amount}</td>
                  <td>{job?.broker_name}</td>
                  <td>{job?.rc_number}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <RateConModal
          show={showRateCon}
          onHide={() => setShowRateCon(false)}
          documentUrl={currentRC?.job?.rate_confirmation_document_url}
        />

        <PodReceipts
          show={showPod}
          onHide={() => setShowPod(false)}
          documents={
            currentPod?.job?.job_trip_documents?.length > 0
              ? currentPod?.job?.job_trip_documents?.filter(d => d.type === 'DROPOFF')
              : []
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default JobsModal
